import { useState, useContext, useEffect } from "react"
import { Field, useFormikContext } from "formik"
import { gql, useLazyQuery } from "@apollo/client"

import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"
import PhoneInput from "react-phone-number-input/input"

import styles from "../../../styles/Form.module.css"

export default function TelerecoveryPhone({ field, block, index }) {
  const userCtx = useContext(UserContext)
  const form = useContext(FormContext)
  const formik = useFormikContext()
  const [visibility, setVisibility] = useState("none")

  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()

  const IS_ACTIVE_TELERECOVERY = gql`
    query isActiveTelerecovery($staff_id: ID!, $organization_id: ID!) {
      service: isMicroservicesActive(
        staff_id: $staff_id
        organization_id: $organization_id
        microservice_name: "Telerecovery"
      ) {
        organization_id
        microservices_id
        microservices_enabled
      }
    }
  `

  const [isActiveTelerecovery] = useLazyQuery(IS_ACTIVE_TELERECOVERY)

  useEffect(() => {
    const organization_id = formik?.getFieldProps("organization_id").value
    const getVisibility = async () => {
      await isActiveTelerecovery({
        variables: {
          staff_id: userCtx.session.user.staff_id,
          organization_id: organization_id,
        },
        fetchPolicy: "no-cache",
        onCompleted: ({ service }) => {
          service?.microservices_enabled === "1"
            ? setVisibility("block")
            : setVisibility("none")
        },
      })
    }
    getVisibility()
  }, [])

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: visibility,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && "*"}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={field.field_name}>
        {({ field: formikField, meta }) => (
          <>
            <PhoneInput
              country="US"
              placeholder="Enter phone number"
              disabled={isDisabled}
              value={formikField.value}
              onChange={formikField.onChange}
              onBlur={formikField.onBlur}
              className="p-inputtext p-component"
            />
            {meta.touched && meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
